import { createInjectionKey as o } from "./ghl-ui.es896.js";
const n = o("n-button-group");
export {
  n as buttonGroupInjectionKey
};
